import { useEffect } from 'react';
import { ensureLanguageConsistency, synchronizeLanguage } from '@/utils/languages';
import i18n, { SUPPORTED } from './config';

export default function I18nInit() {
  useEffect(() => {
    // Ensure all language storage mechanisms are consistent
    ensureLanguageConsistency();

    const onChange = (lng: string) => {
      if ((SUPPORTED as readonly string[]).includes(lng)) {
        // Use synchronization function to ensure all storage mechanisms are updated
        synchronizeLanguage(lng, 'i18n-change-event');
      }
    };
    i18n.on('languageChanged', onChange);
    return () => {
      i18n.off('languageChanged', onChange);
    };
  }, []);

  return null;
}
